import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchUserStart,
  fetchUserSuccess,
  loginFailure,
  loginStart,
  logout,
} from "../store/slices/authSlice";
import { RootState } from "../store/store";
import "./Login.css";
import CustomCarousel from "./Carousel";
const Login: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector(
    (state: RootState) => state.auth
  );

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(loginStart());

    axios
      .post("auth/login", formData)
      .then(() => {
        dispatch(fetchUserStart());
        axios
          .get("/users/me")
          .then(({ data: userData }) => {
            dispatch(fetchUserSuccess(userData));
          })
          .catch(() => {
            axios.post("/auth/logout").then(() => {
              dispatch(logout());
              navigate("/login");
            });
          });
        navigate("/home");
      })
      .catch((error) => {
        console.log("error", error);
        dispatch(loginFailure("Invalid credentials"));
      });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Welcome Back</h1>
        <p className="subtitle">Please enter your details to sign in</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">username</label>
            <input
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter your username"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          {/* <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" /> Remember me
            </label> */}
          {/* <a href="#" className="forgot-password">
              Forgot password?
            </a> */}
          {/* </div> */}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        {/* <p className="signup-prompt">
          Don't have an account? <a href="#">Sign up</a>
        </p> */}
      </div>
      <CustomCarousel />
    </div>
  );
};

export default Login;
